export default __webpack_public_path__ + "static/media/javascript.7e85cc1f.svg";